import { ComparisonItem } from "./comparison-item";

// Controller that handles the events coming from Cora or Miam
// This is where we define the comparison objects for each product, depending on what updates happened in Cora or Miam
// The "resolve" functions return an array of products to be updated (removed / added). Three possible cases :
// - products to be removed from Miam
// - products to be added to Cora
// - products to be removed from Cora
export class ComparisonMap {
  _extIdToComparisonItem = {};
  _comparisonItemType;
  _basketWrapper;

  /**
   *
   * @param retailerBasket
   * @param miamBasket
   * @param comparisonItemType
   */
  constructor(
    basketWrapper,
    retailerBasket,
    miamBasket,
    comparisonItemType = ComparisonItem
  ) {
    this._comparisonItemType = comparisonItemType;
    this._basketWrapper = basketWrapper;
    this.addEntryInMapFromRetailer(retailerBasket);
    this._setFromMiam(miamBasket);
  }

  /**
   *
   * @param extId
   * @returns
   */
  _fetchComparisonItem(extId) {
    let compItem = this._extIdToComparisonItem[extId];
    if (!compItem) {
      compItem = new this._comparisonItemType(this._basketWrapper);
      this._extIdToComparisonItem[extId] = compItem;
    }
    return compItem;
  }

  /**
   *
   */
  cleanNullProducts() {
    Object.keys(this._extIdToComparisonItem).forEach((extId) => {
      const compItem = this._extIdToComparisonItem[extId];
      if (compItem.miamQuantity === 0 && compItem.retailerQuantity === 0) {
        delete this._extIdToComparisonItem[extId];
      }
    });
  }

  // --------------------------------------------------------------------------------------------
  // --- COMING FROM Retailer-----------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  /**
   * add / update / delete  compraisonItem to  _extIdToComparisonItem
   * @param {*} retailerBasket
   */
  updateMapFromRetailer(retailerBasket) {
    this.addEntryInMapFromRetailer(retailerBasket);
    this.deleteEntrieInMapFromRetailer(retailerBasket);
  }

  /**
   *
   * @param {*} retailerBasket
   */
  addEntryInMapFromRetailer(retailerBasket) {
    retailerBasket.forEach((retailerEntrie) => {
      const compItem = this._fetchComparisonItem(retailerEntrie.id);
      compItem.addOrUpdateRetailerProduct(retailerEntrie);
    });
  }

  /**
   *
   * @param {*} retailerBasket
   */
  deleteEntrieInMapFromRetailer(retailerBasket) {
    Object.keys(this._extIdToComparisonItem).forEach((extId) => {
      this.checkIfEntryIsToDeleteFromMap(extId, retailerBasket);
    });
  }

  /**
   * if there is no more item with given extId
   * on Retailer's basket we have to remove it
   * @param extId to check
   * @param retailerBasket current retailer's basket
   */
  checkIfEntryIsToDeleteFromMap(extId, retailerBasket) {
    const compItem = this._extIdToComparisonItem[extId];
    const itemInRetailerBasket = retailerBasket.find(
      (retailerEntrie) => retailerEntrie.id === extId
    );
    if (!itemInRetailerBasket) {
      compItem.clearRetailerProduct();
    }
  }

  /**
   * Retailler can only delete miam's entries
   * @returns
   */
   resolveFromRetailer() {
    let toRemoveFromMiam = [];
    Object.keys(this._extIdToComparisonItem).forEach((extId) => {
      const compItem = this._extIdToComparisonItem[extId];
      const quantityDelta = compItem.miamQuantity - compItem.retailerQuantity;
      if (quantityDelta > 0) {
        toRemoveFromMiam = [...toRemoveFromMiam , ...this.getQuantityToRemove(compItem, quantityDelta)];
        compItem.miamQuantity = compItem.retailerQuantity;
      }
    });
    return toRemoveFromMiam;
  }


  /**
   * while there is still qty to remove 
   * remove qunatity from the next basket entry
   * @param {Object} compItem
   * @param {number}
   * @returns an array of entries to remove from miam
   */
  getQuantityToRemove(compItem, stillToRemove) {
    const toRemoveFromMiam = []
    while(stillToRemove > 0) {
      let beId;
      let quantityRemoved;
      [beId, quantityRemoved] = compItem.removeFirstMiamEntry(stillToRemove);
      if (beId == undefined || quantityRemoved == undefined){
        stillToRemove = 0;
      } else {
        stillToRemove -= quantityRemoved;
        toRemoveFromMiam.push({ id: beId, qty: quantityRemoved});
      }
    }
    return toRemoveFromMiam
  }

  // --------------------------------------------------------------------------------------------
  // --- COMING FROM MIAM -----------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  /**
   *
   * @param {*} miamBasket
   */
  setTargetFromMiam(miamBasket) {
    // console.debug("set target from miam", miamBasket);

    // loop on comparison map and update targetQuantity according to miamB
    this._updateTargetFromMiam(miamBasket);
    // add those missing in comparison item
    this._addTargetFromMiam(miamBasket);
  }

  /**
   *
   * @param {*} miamBasket
   * @returns
   */
  resolveFromMiam(miamBasket) {
    // console.debug("resolve from Miam basket", miamBasket);
    let toPushToRetailer = [];
    Object.keys(this._extIdToComparisonItem).forEach((extId) => {
      toPushToRetailer = [
        ...toPushToRetailer,
        ...this.createOrUpdate(extId, miamBasket),
      ];
    });
    return toPushToRetailer;
  }

  /**
   *
   */
  createOrUpdate(extId, miamBasket) {
    const compItem = this._extIdToComparisonItem[extId];
    let itemsToPush;
    if (compItem.retailerQuantity === 0 && compItem.miamTargetQuantity !== 0) {
      // it is a creation
      // if there is more than one basket id for this product, arbitrary take the first
      // it will result at the same cora creation anyway
      const basketEntry = miamBasket.find(
        (be) => be.id == compItem.firstBasketEntryId
      );
      itemsToPush = compItem.createRetailerProducts(
        basketEntry,
        compItem.miamTargetQuantity
      );
    } else {
      itemsToPush = compItem.updateRetailerProducts();
    }
    compItem.miamQuantity = compItem.miamTargetQuantity;
    return itemsToPush;
  }

  _setFromMiam(miamBasket) {
    miamBasket.forEach((basketEntry) => {
      // TODO : retirer si on a que des basketEntry actives ?
      const extId =
        basketEntry.selectedItem &&
        basketEntry.selectedItem.attributes["ext-id"];
      if (!extId) {
        return;
      }
      const compItem = this._fetchComparisonItem(extId);
      // may already exist if two different ingredients matched same item
      compItem.miamQuantity += basketEntry.attributes.quantity;
      compItem.miamBasketEntryIds[basketEntry.id] =
        basketEntry.attributes.quantity;
    });
  }

  // loop on comparison map and update targetQuantity according to miamB
  _updateTargetFromMiam(miamBasket) {
    Object.keys(this._extIdToComparisonItem).forEach((extId) => {
      const compItem = this._extIdToComparisonItem[extId];
      // you can have différent ingredients (ie different be) matching the same product
      const miamBasketEntries = miamBasket.filter((basketEntry) => {
        return (
          basketEntry.selectedItem &&
          basketEntry.selectedItem.attributes["ext-id"] === extId
        );
      });
      if (miamBasketEntries.length > 0) {
        const quantities = miamBasketEntries.map(
          (be) => be.attributes.quantity
        );
        compItem.miamTargetQuantity = quantities.reduce(
          (a, b) => parseInt(a) + parseInt(b),
          0
        );
        compItem.miamBasketEntryIds = miamBasketEntries.reduce(function (
          map,
          be
        ) {
          map[be.id] = parseInt(be.attributes.quantity);
          return map;
        },
        {});
      } else {
        compItem.miamTargetQuantity = 0;
        compItem.miamBasketEntryIds = {};
      }
    });
  }

  // add comparisonItem and target quantity according to those in miamB missing in comparisonMap
  _addTargetFromMiam(miamBasket) {
    // ---
    miamBasket.forEach((basketEntry) => {
      // TODO : retirer si on a que des basketEntry actives ?
      const extId =
        basketEntry.selectedItem &&
        basketEntry.selectedItem.attributes["ext-id"];
      if (!extId) {
        return;
      }
      if (this._extIdToComparisonItem[extId]) {
        return;
      }
      const compItem = this._fetchComparisonItem(extId);
      // here in fact the target quantity is useless as we we will need to create a product, we can use basketEntry.quantity
      compItem.miamTargetQuantity += basketEntry.attributes.quantity;
      compItem.miamBasketEntryIds[basketEntry.id] =
        basketEntry.attributes.quantity;
    });
  }
}
